import styled from "styled-components"

const StyledNewsletterForm = styled.div`
  .newsletter-status {
    max-width: 500px;
    p {
      color: #fff;
    }
  }
  .newsletter-header {
    margin-bottom: 42px;
    .title {
      font-size: 34px;
      line-height: 40px;
      margin-bottom: 20px;
      color: #e9e9e9;
    }
    .desc {
      font-size: 24px;
      line-height: 32px;
      text-transform: uppercase;
      color: #e9e9e9;
    }
  }
  .newsletter-form {
    position: relative;

    .check-group {
      margin: 23px 0 0 0;

      span {
        font-size: 12px;
        line-height: 20px;
        color: #e9e9e9;
        &::before {
          border-color: #e9e9e9;
        }
      }
      .inp-error {
        top: calc(100% - 5px);
      }
    }
    &__wrapper {
      display: flex;
      max-width: 752px;
      width: 100%;
      margin: 0 0 35px 0;

      div {
        flex: 1;
        padding-right: 30px;
        .inp-label {
          color: #e9e9e9;
        }
        input {
          border-bottom-color: #e9e9e9;
        }
      }
      button {
        min-width: 280px;
        border-color: #e9e9e9;

        span {
          color: #e9e9e9;
        }
      }
    }
  }
  @media screen and (max-width: 1400px) {
    .newsletter-header {
      margin-bottom: 32px;
      .title {
        font-size: 24px;
        line-height: 32px;
        margin-bottom: 10px;
      }
      .desc {
        font-size: 16px;
        line-height: 32px;
      }
    }
    .newsletter-form {
      &__wrapper {
        button {
          min-width: 200px;
        }
      }
    }
  }

  @media screen and (max-width: 600px) {
    .newsletter-header {
      margin-bottom: 30px;
    }
    .newsletter-form {
      .check-group {
        width: 100%;
        min-height: 20px;
      }
      &__wrapper {
        flex-flow: wrap;
        justify-content: center;
        div {
          flex-basis: 100%;
          padding-right: 0;
          margin-bottom: 30px;
          .inp-label {
            text-transform: none;
          }
        }
        button {
          min-width: 100%;
        }
      }
    }
  }
`

export default StyledNewsletterForm
